// Local backend runs on port 4000 (see backend/.env PORT). The default must
// match so the app still works if REACT_APP_BACKEND_URL isn't set at build time.
export const API_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:4000";